import { DEFAULT_UI_LOCALE, normalizeUiLocale } from './locales.js';

/**
 * @typedef {Record<string, string> | string | null | undefined} LocaleMessage
 */

/**
 * @param {LocaleMessage} value
 * @param {string | null | undefined} locale
 */
export function t(value, locale) {
  const lang = normalizeUiLocale(locale);
  if (!value) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  return value[lang] || value[DEFAULT_UI_LOCALE] || Object.values(value)[0] || '';
}

/**
 * @param {LocaleMessage} value
 * @param {string | null | undefined} locale
 * @returns {string[]}
 */
export function tList(value, locale) {
  const lang = normalizeUiLocale(locale);
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'object' && (value[lang] || value[DEFAULT_UI_LOCALE])) {
    const list = value[lang] || value[DEFAULT_UI_LOCALE];
    return Array.isArray(list) ? list : [];
  }
  return [];
}
